<script setup lang="ts">
/** Ortak birincil eylem dugmesi — dort adimin "Devam et / Oturum ac / Sec /
 * Ac" dugmeleri ayni gorsel + yukleniyor davranisini paylasir. */
defineProps<{
  readonly label: string
  readonly loading?: boolean
  readonly disabled?: boolean
  readonly type?: 'button' | 'submit'
}>()

defineEmits<{ click: [] }>()
</script>

<template>
  <button
    :type="type ?? 'button'"
    class="fw-auth-button"
    :disabled="disabled === true || loading === true"
    @click="$emit('click')"
  >
    {{ label }}
  </button>
</template>

<style scoped>
.fw-auth-button {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  background: var(--fw-primary);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin-top: 18px;
}

.fw-auth-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
